import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTheme } from "styled-components";
import { DateDisplay } from "../../../components";
import { ConfirmModal } from "../../../components/modals";
import { AutoFitCell, FixedCell } from "../../../components/tables/StandardTable";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { ThemedSpan } from "../../../components/utilities";

const DateTimeDisplay = (props) => <DateDisplay {...props} local format="DD/MM/yyyy @ HH:mm" />

const ColumnDropdownToggle = forwardRef(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon="fa-ellipsis" />
    </div>
));

const StandardParagraphTableActionDropdown = ({ onPublishClick, onDeleteClick }) => {
    return <AutoFitCell className="has-pointer">
        <Dropdown className="caret-off">
            <Dropdown.Toggle as={ColumnDropdownToggle} />
            <Dropdown.Menu>
                <Dropdown.Item onClick={onPublishClick}>Publish</Dropdown.Item>
                <Dropdown.Item onClick={onDeleteClick}>Delete</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    </AutoFitCell>
}

const UserOperationColumn = ({
    date,
    id,
    by,
    variant = "",
    width = 20
}) => (
    <FixedCell className="text-truncate" width={width}>
        <ThemedSpan variant={variant}>
            {
                date == null
                    ? "Never"
                    : <>
                        <DateTimeDisplay>{date}</DateTimeDisplay> by {by}
                    </>
            }
        </ThemedSpan>
    </FixedCell>
);

const StandardParagraphTableRow = ({ data, index, style, onNameClick, onPublish, onDelete }) => {
    const { height } = style;
    const theme = useTheme();

    const [showPublish, setShowPublish] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    if (data[index] == null) {
        return <TableLoadingRow style={{ height }} />
    }

    const {
        standardParagraphId,
        type,
        name,
        documentId,
        createdDate,
        createdById,
        createdBy,
        lastOpenedDate,
        lastOpenedById,
        lastOpenedBy,
        publishedDate,
        publishedById,
        publishedBy,
        isPublished
    } = data[index] || {};

    return <>
        <ConfirmModal
            show={showPublish}
            dialogTitle={"Publish Standard Paragraph content"}
            confirmButtonText="Publish"
            proceed={() => onPublish(standardParagraphId)}
            cancel={() => setShowPublish(false)}
            size="md"
            message={
                !isPublished
                    ? `Would you like to publish the paragraph content for Standard Paragraph '${name}'?`
                    : <>
                        Are you sure you want to publish '{name}'?
                        <br />
                        It has not been opened since <DateTimeDisplay>{lastOpenedDate}</DateTimeDisplay>, prior to it's last publish on  <DateTimeDisplay>{publishedDate}</DateTimeDisplay>.
                    </>
            }
        />
        <ConfirmModal
            show={showDelete}
            dialogTitle={"Delete Standard Paragraph"}
            message={`Are you sure you want to delete the Standard Paragraph '${name}'?`}
            confirmButtonVariant="danger"
            confirmButtonText="Delete"
            proceed={() => onDelete(standardParagraphId)}
            cancel={() => setShowDelete(false)}
        />
        <tr style={{ height }} className="align-middle">
            <FixedCell width={25}>
                <span className="d-flex flex-column align-items-start text-truncate">
                    <button className="anchor" onClick={() => onNameClick(standardParagraphId, documentId)}>
                        {name}
                    </button>
                    <span className="fs-smaller text-muted">{type}</span>
                </span>
            </FixedCell>
            <UserOperationColumn
                date={createdDate}
                id={createdById}
                by={createdBy}
            />
            <UserOperationColumn
                date={lastOpenedDate}
                id={lastOpenedById}
                by={lastOpenedBy}
            />
            <UserOperationColumn
                date={publishedDate}
                id={publishedById}
                by={publishedBy}
                variant={isPublished ? "" : "warning"}
            />
            <AutoFitCell className="text-center">
                <StandardParagraphTableActionDropdown
                    onPublishClick={() => setShowPublish(true)}
                    onDeleteClick={() => setShowDelete(true)}
                />
            </AutoFitCell>
        </tr>
    </>
}

export default StandardParagraphTableRow;